export class RoutePath {
    static initial: string = '/'
    static clipDetail: string = '/clip-detail'
    static channelDetail: string = '/channel-detail'
    static login: string = '/login'
    static register: string = '/register'
    static forgotPassword: string = '/forgot-password'
    static profile: string = '/profile'
    static qrLoginConfirm: string = '/login/qr/confirm'
}